/**
 * API Configuration for Etherith
 * Centralized configuration for API endpoints
 */

const isDevelopment = import.meta.env.DEV

// Base URL for API endpoints
export const API_BASE_URL = 'https://etherith-production.pages.dev' // Use Pages URL for both dev and prod

// AI Worker URL (separate from main API)
export const AI_WORKER_URL = 'https://etherith-ai-worker.carl-6e7.workers.dev'

// Pinata Worker URL (dedicated IPFS upload worker)
export const PINATA_WORKER_URL = 'https://etherith-pinata-worker.carl-6e7.workers.dev'

// API Endpoints
export const API_ENDPOINTS = {
  IPFS_UPLOAD: `${PINATA_WORKER_URL}`, // Use dedicated Pinata worker
  AI_MODERATE: `${AI_WORKER_URL}/moderate`, // Use dedicated AI worker for moderation
  AI_ENHANCE: `${AI_WORKER_URL}` // Use dedicated AI worker for both dev and prod
}

// Helper function to get full URL
export const getApiUrl = (endpoint) => {
  return API_ENDPOINTS[endpoint] || endpoint
}
